import { useSelector } from 'react-redux';
import { selectCulture } from '../store/selectors';
import Lang from '../languages/lang';
import csCZ from '../languages/cs_CZ';
import enUS from '../languages/en_US';

const useTexts = () => {
  const culture = useSelector(selectCulture);
  const getDictionary = (): Lang => {
    switch (culture) {
      case 'en-US':
        return enUS;
      default:
        return csCZ;
    }
  };

  return getDictionary();
};

export default useTexts;
